export class Plantillas
{
    public idPlantillaPk: number;   
    public idAnt:number;
    public dsc: string;
    public posicion: number;
}